<template>
    <el-row>
        <el-col :span="8" class="filter-layout-text-left">
            <span>Booking History</span>
        </el-col>
        <el-col :span="16" class="filter-layout-text">
            <el-date-picker
                v-model="datePickerNow"
                type="date"
                placeholder="Fillter Date">
            </el-date-picker>
            <el-checkbox v-model="isShowShop" class="fillter-pad">แสดงแค่บางร้าน</el-checkbox>
            <el-autocomplete
                popper-class="my-autocomplete"
                v-model="state"
                :fetch-suggestions="querySearch"
                placeholder="ค้นหา"
                @select="handleSelect">
                <i
                    class="el-icon-search el-input__icon"
                    slot="suffix"
                    @click="handleIconClick">
                </i>
                <template slot-scope="{ item }">
                    <div class="value">{{ item.value }}</div>
                    <span class="link">{{ item.link }}</span>
                </template>
            </el-autocomplete>
        </el-col>
    </el-row>
</template>

<script>
export default {
    data () {
        return {
            links: [],
            state: '',
            datePickerNow: '',
            isShowShop: false
        }
    },
    methods: {
        querySearch (queryString, cb) {
            var links = this.links
            var results = queryString ? links.filter(this.createFilter(queryString)) : links
            cb(results)
        },
        createFilter (queryString) {
            return (link) => {
                return (link.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0)
            }
        },
        loadAll () {
            return [
                { 'value': 'vue', 'link': 'https://github.com/vuejs/vue' },
                { 'value': 'element', 'link': 'https://github.com/ElemeFE/element' },
                { 'value': 'cooking', 'link': 'https://github.com/ElemeFE/cooking' },
                { 'value': 'mint-ui', 'link': 'https://github.com/ElemeFE/mint-ui' },
                { 'value': 'vuex', 'link': 'https://github.com/vuejs/vuex' },
                { 'value': 'vue-router', 'link': 'https://github.com/vuejs/vue-router' },
                { 'value': 'babel', 'link': 'https://github.com/babel/babel' }
            ]
        },
        handleSelect (item) {
            console.log(item)
        },
        handleIconClick (ev) {
            console.log(ev)
        }
    },
    mounted () {
        this.links = this.loadAll()
    }
}
</script>

<style lang="scss" scoped>
  .my-autocomplete {
    li {
      line-height: normal;
      padding: 7px;

      .value {
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .link {
        font-size: 12px;
        color: #b4b4b4;
      }
    }
  }

  .filter-layout-text-left{
      text-align: left;
      font-size: 22px;
  }
  .filter-layout-text{
        text-align: end;
        .confirm-btn-style{
            background: #08A7A3;
            color: white;
        }
        .fillter-pad{
            padding: 0 15px;
        }
  }
</style>
